export default {
    GET_APP_TEXT : 'احصل على التطبيق',
    DOWNLOAD_APP_TEXT : 'تحميل التطبيق',
    DOWNLOAD_APP_DESC : "حمل تطبيق لايف الدار لتجربة أفضل"
}